export default __webpack_public_path__ + "static/4-2658c984e8ac216713861e821cc9d0ff.png";